import { trackEvent as t } from '../track';
import { MetadataAppType } from './propertyTypes';

interface ConnectAppsProps {
  '[Metadata] App type': MetadataAppType,
}

export const onboarding = {
  connectApps: {
    addSuccessful: (props: ConnectAppsProps) => t('[Onboarding] [Connect Apps] Add Complete', props),
    nextStep: () => t('[Onboarding] [Connect Apps] Initiate next step'),
    view: () => t('[Onboarding] [Connect Apps] View'),
  },
  extension: {
    install: () => t('[Onboarding] [Extension] Initiate install'),
    nextStep: () => t('[Onboarding] [Extension] Initiate next step'),
    view: () => t('[Onboarding] [Extension] View'),
  },
  loader: {
    view: () => t('[Onboarding] [Loader] View'),
  },
  organization: {
    invite: {
      copy: () => t('[Onboarding] [Organization] [Invite] Copy slug'),
      nextStep: () => t('[Onboarding] [Organization] [Invite] Initiate next step'),
      view: () => t('[Onboarding] [Organization] [Invite] View'),
    },
    landing: {
      initiateJoin: () => t('[Onboarding] [Organization] [Landing] Initiate join'),
      nextStep: () => t('[Onboarding] [Organization] [Landing] Initiate next step'),
      view: () => t('[Onboarding] [Organization] [Landing] View'),

    },
    setup: {
      nextstep: () => t('[Onboarding] [Organization] [Setup] Initiate next step'),
      rename: () => t('[Onboarding] [Organization] [Setup] Rename'),
      view: () => t('[Onboarding] [Organization] [Setup] View'),
    }
  },
  welcomeModal: {
    close: () => t('[Onboarding] [Welcome Modal] Close'),
    view: () => t('[Onboarding] [Welcome Modal] View'),
  },
  complete: () => t('[Onboarding] Complete'),
  start: () => t('[Onboarding] Start'),
};